module.exports = __webpack_public_path__ + "22c8f53b72bb0520da0bac2aaeb8f342.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-info-blue.svg
// module id = hbJg
// module chunks = 5